import { render, staticRenderFns } from "./LeadsTable.vue?vue&type=template&id=2808d8b8&"
import script from "./LeadsTable.vue?vue&type=script&lang=js&"
export * from "./LeadsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports